export default "__VITE_ASSET__CEipMORs__"